import { useState } from "react";
import { ORDO_NODES } from "@/content/ordo";
import { ExplorerFrame, Swap } from "@/components/site/ExplorerFrame";
import { ArchitectureDiagram } from "./ArchitectureDiagram";
import { ArchitectureText, NodePanel } from "./ArchitecturePanel";

export const ArchitectureExplorer = () => {
  const [sel, setSel] = useState("whole");
  const [mode, setMode] = useState("explore");
  const node = ORDO_NODES[sel];
  const related = sel === "whole" ? null : new Set([sel, ...node.relates]);
  return (
    <ExplorerFrame
      testid="architecture-explorer"
      label="Architecture explorer"
      hint="Select a responsibility or expression to see what it concerns, why it matters, and how it relates."
      mode={mode}
      onMode={setMode}
    >
      {mode === "explore" ? (
        <div className="grid lg:grid-cols-12">
          <div className="border-b border-o-line p-5 sm:p-7 lg:col-span-8 lg:border-b-0 lg:border-r">
            <ArchitectureDiagram sel={sel} related={related} onSelect={setSel} />
          </div>
          <div className="p-5 sm:p-7 lg:col-span-4" aria-live="polite">
            <Swap k={sel}>
              <NodePanel node={node} onSelect={setSel} />
            </Swap>
          </div>
        </div>
      ) : (
        <ArchitectureText />
      )}
    </ExplorerFrame>
  );
};
